import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EventService, ScApiService } from '@sc-ui';
import { distinctUntilChanged } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { AppChatsService } from 'src/services/app-chats.service';
import { UserService } from 'src/services/user.service';
import { LocalizationService } from 'src/services/localization.service';
import { fadeIn } from 'src/transitions';
import { texts } from './projects.texts';

@Component({
  standalone: false,
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss'],
  animations: [ fadeIn ]
})
export class ProjectsComponent implements OnInit {

  texts = texts;

  state = 'out';

  ownProjectsOnly = true;

  status = 'All';

  ownership = 'Self';

  type = 'All';

  statusNames = texts.statusNames;

  typeNames = texts.typeNames;

  ownershipNames = texts.ownershipNames;

  hasMoreItems = false;

  isLoading = false;

  page = 1;

  q = '';

  projects : any = [];

  totalCount = 0;

  // a pass that is still in flight would push its results into the list of the
  // pass that replaced it, so every load is tied to the pass that started it
  private loadPass = 0;

  private loadSubscription : Subscription;

  constructor(private api : ScApiService, private chatbot : AppChatsService, public user : UserService, public loc : LocalizationService, private route : ActivatedRoute, private router : Router) { }

  ngOnInit() {
    

    this.route.queryParams
      .pipe(distinctUntilChanged((a : any, b : any) =>
        a.status == b.status && a.ownership == b.ownership && a.type == b.type))
      .subscribe((params : any) => {
        this.status = params.status ?? 'Sourcing';
        this.ownership = params.ownership ?? 'Self';
        this.type = params.type ?? 'All';
        this.search();
      });
  } 

  newProject()
  {    
    this.chatbot.newProjectChat();
  }

  searchTimeout = null;

  searchSoon()
  {
    if (this.searchTimeout) clearTimeout(this.searchTimeout);

    this.searchTimeout = setTimeout(() => {
      this.search();
    }, 500);

  }

  reload()
  {
    this.router.navigateByUrl('projects?status=' + this.status + '&ownership=' + this.ownership + '&type=' + this.type);
  }

  search()
  {
    this.loadPass++;
    this.page = 0;
    this.projects = [];
    this.loadMore();
  }

  loadMore()
  {    
    if (this.loadSubscription) this.loadSubscription.unsubscribe();

    this.isLoading = true;
    this.page++;

    var pass = this.loadPass;

    this.loadSubscription = this.api.get(`projects/search?q=${this.q}&page=${this.page}&status=${this.status}&ownership=${this.ownership}&type=${this.type}`).subscribe({
      next: (d : any) => {
        if (pass != this.loadPass) return;
        this.projects.push.apply(this.projects, d.Projects);
        this.totalCount = d.TotalCount;
        this.hasMoreItems = this.projects.length < d.TotalCount;
        this.isLoading = false;
        this.state = 'in';
      },
      error: () => {
        if (pass != this.loadPass) return;
        this.isLoading = false;
        this.state = 'in';
      }
    });
  }

}
